export default "__VITE_ASSET__eaaa316e__"